module.exports = __webpack_public_path__ + "static/media/feishu3.34daf4b3.mp4";